
import SidebarItem from './SidebarItem'
import { mapGetters } from 'vuex'
export default {
	name: 'Sidebar',
	components: { SidebarItem },
	props: {
		menuList: {
			type: Array,
			required: true
		}
	},
	computed: {
		centerMenuList() {
			return this.menuList.filter(item => !item.hide)
		},
		activeMenu() {
			return this.$route.path
		},
		...mapGetters({
			userAccount: 'user/userAccount'
		})
	},
	data() {
		return {
			activeNames: [],
			HistoryList: []
		}
	},
	methods: {
		openMenu(path) {
			this.HistoryList = JSON.parse(localStorage.getItem('closeMenu')) || this.activeNames
			this.HistoryList.unshift(path)
			localStorage.setItem('closeMenu', JSON.stringify(this.HistoryList))
		},
		closeMenu(path) {
			this.HistoryList = JSON.parse(localStorage.getItem('closeMenu')) || this.activeNames
			if (this.HistoryList.length > 0) {
				if (this.HistoryList.indexOf(path) !== -1) {
					this.HistoryList.splice(this.HistoryList.indexOf(path), 1)
				}
			}
			localStorage.setItem('closeMenu', JSON.stringify(this.HistoryList))
		},
		activeNamesArr(v) {
			console.log('activeNamesArr', v)
			let arr = []
			v.map(item => {
				if (item.children) {
					// 权益兑换菜单默认收起
					if (item.path !== '/account/equityExchange') {
						arr.push(item.path)
					}
				}
			})
			this.activeNames = JSON.parse(localStorage.getItem('closeMenu')) || arr
		}
	},
	mounted() {
		// 展开折叠
		this.activeNamesArr(this.menuList)
	}
}
